<template>
  <div>
    <navBar />
    <div class="main main-container">
      <div class="banner">
        <img src="@/assets/images/about/banner.png" />
        <div class="banner-title">关于我们</div>
      </div>
      <div class="wrap-nav">
        <div>
          <div class="company-describe">
            英檬科技是一家创新型营销技术与解决方案服务商，我们致力于帮助品牌实现用户精细化与数字化运营，增强用户价值转化，提高业务价值。
          </div>
          <div class="logo">
            <img src="@/assets/images/about/logo.png" />
          </div>
          <div class="company-slogan">
            <span>智用<span style="color: #64ac3a">数据</span>，</span>
            <span>赋能<span style="color: #64ac3a">运营</span></span>
            <div class="company-slogan-des">
              公司logo中的蓝色代表技术与数据，绿色代表创造力与服务力，英檬科技是一家技术与服务的综合方案服务商。
            </div>
          </div>
          <div class="corporate-vision">
            <div class="corporate-vision-title">英檬科技的三大愿景</div>
            <div class="corporate-vision-describe">
              <div>
                <img src="@/assets/images/about/vision1.png" />
                <div>为品牌设计更适应于未来的用户精细化运营业务策略</div>
              </div>
              <div>
                <img src="@/assets/images/about/vision2.png" />
                <div>精于用户，帮助品牌实现更佳用户数据资产管理与价值提升</div>
              </div>
              <div>
                <img src="@/assets/images/about/vision3.png" />
                <div>通过技术与产品帮助企业实现数字化升级与持续业务增长</div>
              </div>
            </div>
          </div>
          <!-- <div class="partner-box">
            <div class="partner-box-title">合作伙伴</div>
            <div class="partner-box-slogan">
              携手产业链合作伙伴与生态伙伴，共创品牌服务生态
            </div>
            <div class="partner-box-logo">
              <div>
                <img src="@/assets/images/about/cce.png" />
                <span/>
              </div>
              <div>
                <img src="@/assets/images/about/yinzhida.png" />
                 <span/>
              </div>
              <div>
                <img src="@/assets/images/about/megvll.png" />
                <span/>
              </div>
              <div>
                <img src="@/assets/images/about/Alibaba.png" />
                <span/>
              </div>
              <div>
                <img src="@/assets/images/about/Netease.png" />
              </div>
              <div>
                <img src="@/assets/images/about/i.png" />
                <span/>
              </div>
              <div>
                <img src="@/assets/images/about/meritco.png" />
                 <span/>
              </div>
              <div>
                <img src="@/assets/images/about/paradigm.png" />
                <span/>
              </div>
              <div>
                <img src="@/assets/images/about/tencent.png" />
                <span/>
              </div>
              <div>
                <img src="@/assets/images/about/baison.png" />
              </div>
            </div>
          </div> -->
          <div class="contact-us">
              <div class="contact-us-title">联系我们</div>
              <div class="contact-us-content">
                  <div><img src="@/assets/images/about/contactus.png" /> </div>
                  <div class="contact-information">
                    <div>
                      <p><span>电</span><span>话</span></p>：021-62660613 
                    </div>
                    <div>
                      <p><span>合</span><span>作</span><span>联</span><span>系</span></p>：marketing@indation.com
                    </div>
                    <div>
                      <p><span>公</span><span>司</span><span>地</span><span>址</span></p>：上海市普陀区智慧产业科技园2号楼101
                    </div>
                    <div>
                      <p><span>邮</span><span>编</span></p>：200063
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  data() {
    return {
    };
  },
  components: {
    navBar,
    footerBar
  },
  created() {},

  methods: {},
};
</script>
<style  lang="scss" scoped>
.main {
  max-width: 1920px;
  min-width: $min-screen-width;
  overflow: hidden;
  margin: 0 auto;
  font-family: Source Han Sans CN;

  .banner {
    position: relative;
    height: 430px;

    .banner-title {
      position: absolute;
      top: 180px;
      left: 645px;
      font-size: 40px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .wrap-nav div {
    margin: 0 auto;
  }

  .wrap-nav {
    margin-top: 110px;
    .company-describe {
      width: 920px;
      height: 63px;
      font-size: $font-size-20;
      text-align: center;
      font-weight: 400;
      line-height: 37px;
      color: #707070;
    }
    .logo {
      margin-top: 108px;
      text-align: center;
    }
    .company-slogan {
      margin-top: 90px;
      // font-size: 0;
      text-align: center;
      font-weight: bold;
      // color: #64ac3a;
      color: #15317f;
      font-family: SourceHanSansCN-Bold;
    }

    .company-slogan span{
      font-size: 40px;
    }

    .company-slogan-des {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #707070;
      padding: 30px 0 90px
    }
    
    .company-slogan-title {
      margin: 30px 0 90px 0;
      font-size: 18px;
      color: #707070;
    }
    .corporate-vision {
      height: 525px;
      background: #f9fbff;
      margin-bottom: 90px;
      text-align: center;

      .corporate-vision-title {
        padding-top: 90px;
        font-size: 32px;
        position: relative;
        color: #333333;
      }
      .corporate-vision-title:after {
        content: " ";
        transform: translateX(-50%);
        width: 60px;
        height: 2px;
        background: #1f71ff;
        position: absolute;
        top: 147px;
        left: 50%;
      }
      .corporate-vision-describe {
        display: flex;
        margin-top: 120px;
        letter-spacing: 2px;
        width: 1088px;
      }

      .corporate-vision-describe > div > div {
        width: 300px;
        font-size: $font-size-14;
        line-height: 20px;
        color: #707070;
        padding-top: 50px;
      }
    }

    .partner-box {
      text-align: center;
      margin-bottom: 50px;
      .partner-box-title {
        position: relative;
        font-size: 32px;
        color: #333333;
      }

      .partner-box-title:after {
        content: " ";
        transform: translateX(-50%);
        width: 60px;
        height: 2px;
        background: #1f71ff;
        position: absolute;
        top: 58px;
        left: 50%;
      }

      .partner-box-slogan {
        margin: 67px 0 50px 0;
        font-size: $font-size-20;
        color: #707070;
      }
      .partner-box-logo {
        display: flex;
        justify-content:center;
        flex-wrap: wrap;
        align-items: center;
        height: 300px;
        width: 1200px;
      }

    .partner-box-logo > div{
        display: flex;
        justify-content:center;
        align-items: center;
        position: relative;
        width: 240px;
      }

     .partner-box-logo >div >span{
         width: 0px;
         position: absolute;
         right: 0;
        height: 60px;
        border: 1px solid #D9D9D9;
      }
    }

    .contact-us{
      margin-top: 90px;
      margin-bottom: 132px;
      width:1000px;
      .contact-us-title {
        text-align: center;
        position: relative;
        font-size: 32px;
        color: #333333;
      }

     .contact-us-title:after {
        content: " ";
        transform: translateX(-50%);
        width: 60px;
        height: 2px;
        background: #1f71ff;
        position: absolute;
        top: 58px;
        left: 50%;
      }
      .contact-us-content{
          margin-top: 66px;
          display: flex;
          justify-content: center;
          align-items: center;
      }
      .contact-information{
        div {
          font-size: $font-size-18;
          line-height: 40px;
          color: #707070;
          display: flex;
          p {
            display: flex;
            width: 75px;
            justify-content: space-between;
          }
        }
      }
 
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/about/index.vue